import { useRef, type ReactNode } from 'react';

import { usePresence, useSheetDrag } from '../lib/motion/hooks';

/** How long the sheet takes to leave; it stays mounted until then. */
const EXIT_MS = 220;

/**
 * The phone's bottom sheet (the Más menu): it rises over a fading scrim,
 * follows a downward drag and leaves the same way. One component for both
 * shells, so every look's sheet moves alike. While it leaves it is inert and
 * hidden from assistive tech: it is already closed, only still moving.
 */
export function Sheet({ open, label, onClose, className, children }: { open: boolean; label: string; onClose: () => void; className?: string; children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  const { mounted, phase } = usePresence(open, { exitMs: EXIT_MS });
  const drag = useSheetDrag(ref, onClose);
  if (!mounted) return null;
  return (
    <>
      <button type="button" className="sheet-scrim" data-phase={phase} aria-label="Cerrar menú" onClick={onClose} />
      <div ref={ref} className={className ? `sheet ${className}` : 'sheet'} data-phase={phase} inert={phase === 'closing'} aria-hidden={phase === 'closing' || undefined} role="dialog" aria-label={label} {...drag}>
        {children}
      </div>
    </>
  );
}
